import { render } from "./SignUpModalComponent.vue?vue&type=template&id=27455ab4&scoped=true"
import script from "./SignUpModalComponent.vue?vue&type=script&lang=js"
export * from "./SignUpModalComponent.vue?vue&type=script&lang=js"

import "./SignUpModalComponent.vue?vue&type=style&index=0&id=27455ab4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27455ab4"]])

export default __exports__